import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetDeploymentFrequencyRange from "shared/DoraMetrics/useGetDeploymentFrequencyRange";

import useDoraDateRange from "../useDateRange";

const useDoraDeploymentFrequencyRange = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { range, hasRuns, loading, error, refetch, networkStatus } = useGetDeploymentFrequencyRange(
    {
      startTimeUnix: getUnixTime(startTime),
      endTimeUnix: getUnixTime(endTime),
    }
  );

  const isLoading = (loading && !range) || networkStatus === NetworkStatus.refetch;

  return {
    range,
    hasRuns,
    isLoading,
    error,
    refetch,
  };
};

export default useDoraDeploymentFrequencyRange;
